import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import classNames from "classnames";
import useUniqueId from "../Hooks/useUniqueId";
import ObjectService from "../../Services/Shared/Object.service";
import { useFormFormatContext } from "../UI/FormFormat/FormFormat";
const SearchField = ({ name, label, required, helpText, disabled, as, clearFormFieldsOnChange, multiRequiredFix, maxSelectedItems, noBottomMargin, }) => {
    const makeId = useUniqueId()[1];
    const { errors, setValue } = useFormContext();
    const error = React.useMemo(() => ObjectService.getPropertyAtPath(errors, name), [errors, name]);
    const context = useFormFormatContext();
    // @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
    const validateArrayField = (value) => {
        if (multiRequiredFix && Array.isArray(value) && value.length === 0) {
            setValue(name, undefined);
            return `${label} is required`;
        }
        if (maxSelectedItems && value.length > maxSelectedItems) {
            return `Maximum amount of selected items exceeded: ${maxSelectedItems}`;
        }
        return true;
    };
    return (_jsxs("div", { className: classNames("form-group", {
            required,
            "mr-2": context.inline,
            "mb-0": noBottomMargin,
        }), children: [label && !context.inline && (_jsx("label", { htmlFor: makeId(name), children: label })), _jsx("div", { style: context.inline ? { width: 300 } : undefined, children: _jsx(Controller
                // @ts-expect-error - TS2322 - Type 'ReactNode' is not assignable to type '"symbol" | "object" | "title" | "template" | "cite" | "data" | "form" | "label" | "pattern" | "span" | "summary" | "style" | FunctionComponent<any> | "big" | ... 162 more ... | ReactElement<...>'.
                , { 
                    // @ts-expect-error - TS2322 - Type 'ReactNode' is not assignable to type '"symbol" | "object" | "title" | "template" | "cite" | "data" | "form" | "label" | "pattern" | "span" | "summary" | "style" | FunctionComponent<any> | "big" | ... 162 more ... | ReactElement<...>'.
                    as: as({
                        placeholder: context.inline && label ? label : undefined,
                        hasError: !!error,
                        errorMessage: error === null || error === void 0 ? void 0 : error.message,
                        disabled,
                        "aria-label": name,
                    }), name: name, rules: {
                        required: required ? `${label} is required` : false,
                        validate: multiRequiredFix ? validateArrayField : undefined,
                    }, onChange: ([selected]) => {
                        if (clearFormFieldsOnChange) {
                            clearFormFieldsOnChange.forEach((fieldName) => {
                                setValue(fieldName, null);
                            });
                        }
                        return selected;
                    } }) }), helpText && _jsx("small", { className: "text-muted", children: helpText })] }));
};
export default SearchField;
